import styled from "styled-components";
import { Z_INDEX } from "@constants";
import { theme } from "@utilities";
import { ClipLoaderCommon } from "./LoaderCommon";
import { signupOfferCopy } from "src/Module/Checkout/signupOfferConfig";

/**
 * Covers the page while a social sign-in finishes.
 *
 * Apple and Google both hand back through a page that is not where the visitor
 * was going — the backend callback lands on /login, the route guard bounces a
 * signed-in visitor home, and only then does the handler send them on. Without a
 * cover that reads as several unrelated pages flashing past.
 */
export const SignInProgressCover = () => (
    <Cover role="status" aria-live="polite">
        <ClipLoaderCommon color={theme.colors.main} size={48} margin={0} />
        <CoverText>{signupOfferCopy.finishingHeadline}</CoverText>
    </Cover>
);

const Cover = styled.div`
    position: fixed;
    inset: 0;
    z-index: ${Z_INDEX.MODAL_HIGH};
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;

    /* The shared loader is built to fill a page on its own (flex: 1), which in a
       centred column stretches and shoves the caption to the bottom edge. Sized
       to its content here so the pair sits together in the middle. */
    .clip-loader {
        flex: 0 0 auto;
        margin: 0;
    }
`;

const CoverText = styled.p`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: ${(p) => p.theme.colors.black};
`;
